import { FavoriteTokenRequestAction } from "nvs-types";
import { FAVORITES } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeApiFavoritedCall } from "../../services/api/favorites/postUserFavorited";

type PostFavorite = {
  tokenId: string;
  chainId: number;
  contractAddress: string;
  action: FavoriteTokenRequestAction;
};

const useUserFavoriteTokenMutation = (
  swooshHandle: string,
  onError?: (response: any) => void,
  onSuccess?: () => void,
) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async ({ tokenId, chainId, contractAddress, action }: PostFavorite) =>
      await makeApiFavoritedCall(tokenId, chainId, contractAddress, action),
    {
      onSuccess: () => {
        onSuccess && onSuccess();
        return queryClient.invalidateQueries([swooshHandle, FAVORITES]);
      },
      onError({ response }) {
        return onError && onError(response);
      },
    },
  );
  return mutation;
};

export default useUserFavoriteTokenMutation;
